import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import _ from 'lodash';
import { toast } from '@heroui/react';

const cn = (...inputs) => twMerge(clsx(inputs));

const generateUID = (length) =>
    Array.from({ length: length }, () =>
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 62)),
    ).join('');

const makeObjectLowercase = (obj) => {
    return _.transform(obj, (result, value, key) => {
        const lowerKey = _.isString(key) ? key.toLowerCase() : key; // Convert keys to lowercase

        let lowerValue;
        if (_.isDate(value)) {
            // Handle dates: leave them as-is or format them as needed
            lowerValue = value; // Keep the date as-is (or use value.toISOString() for consistent formatting)
        } else if (_.isObject(value) && !_.isArray(value)) {
            // Recursively process objects
            lowerValue = makeObjectLowercase(value);
        } else if (_.isString(value)) {
            // Convert strings to lowercase
            lowerValue = value.toLowerCase();
        } else {
            // Leave other types as-is (numbers, booleans, etc.)
            lowerValue = value;
        }

        result[lowerKey] = lowerValue;
    });
};

const toTitleCase = (input) => {
    if (typeof input === 'string') {
        return input.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }

    return input;
};

export { cn, generateUID, makeObjectLowercase, toTitleCase };
